'use client';

import { Box, Button, Container, Grid, Typography } from '@mui/material';
import cx from 'clsx';
import { useTranslations } from 'next-intl';

import { howWeBuildProducts } from '@/config/how-we-build-products.config';
import { Link } from '@/i18n/navigation';
import useScrollReveal from '@/utils/hooks/useScrollReveal';

import HowWeBuildProductCard from './HowWeBuildProductCard';
import styles from './HowWeBuildProductsSection.module.scss';

interface HowWeBuildProductsSectionProps {
  isAboutPage?: boolean;
}

const HowWeBuildProductsSection = ({ isAboutPage }: HowWeBuildProductsSectionProps) => {
  const t = useTranslations('common.howWeBuildProductsSection');
  const { setRef, isVisible } = useScrollReveal<HTMLDivElement>(howWeBuildProducts.length);

  return (
    <Container component="section" maxWidth="xl" className={cx(styles.container, { [styles.aboutPage]: isAboutPage })}>
      <Typography variant="h2" textAlign="center" className={styles.title}>
        {t('title')}
      </Typography>
      <Typography variant="body1" textAlign="center" className={styles.description}>
        {t('description')}
      </Typography>
      <Button component={Link} href="/services" className={styles.button}>
        {t('buttonText')}
      </Button>
      <Grid container spacing={{ xs: 10.5, md: 3 }} mt={{ xs: 10, md: 8 }}>
        {howWeBuildProducts.map(({ key, ...product }, index) => (
          <Grid size={{ xs: 12, md: 6, xl: 3 }} key={key}>
            <Box ref={setRef(index)} className={cx(styles.card, { [styles.visible]: isVisible(index) })}>
              <HowWeBuildProductCard {...product} />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default HowWeBuildProductsSection;
